import _get from 'hs-lodash/get';
import { useCallback, useContext, useEffect } from 'react';
import { PROPERTIES_LIMIT } from '../constants/properties';
import { objectTypes, pluralTypeToId, pluralTypeToSingle } from '../constants/types';
import { PropertiesContext } from '../contexts/properties/context';
import useSelectValues from './useSelectValues';
const useSelectLoadOptions = ({
  property,
  objectType
}) => {
  const {
    externalOptions,
    propertiesActions,
    mentionOwners
  } = useContext(PropertiesContext);
  const {
    fetchedExternadOptions,
    hardcodedRefType
  } = useSelectValues({
    property,
    objectType
  });
  const loadOptions = useCallback(() => {
    if (fetchedExternadOptions && fetchedExternadOptions.hasMore === false && _get(fetchedExternadOptions.results, 'length', 0)) {
      return;
    }
    const typeId = pluralTypeToId[objectType || objectTypes.contacts];
    propertiesActions.getExternalOptions({
      query: '',
      referenceType: property.referenceType || property.referencedObjectType || hardcodedRefType.current || '',
      offset: fetchedExternadOptions && fetchedExternadOptions.offset ? +fetchedExternadOptions.offset : 0,
      limit: PROPERTIES_LIMIT,
      typeId,
      delay: 0,
      crmObjectType: pluralTypeToSingle[objectType],
      externalOptions,
      mentionOwners
    });
  }, [externalOptions, fetchedExternadOptions, mentionOwners, objectType, propertiesActions, property, hardcodedRefType]);

  // load options
  useEffect(() => {
    if (property.externalOptions) {
      loadOptions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [property.externalOptions]);
  return {
    loadOptions
  };
};
export default useSelectLoadOptions;